import { render, staticRenderFns } from "./info-table.vue?vue&type=template&id=4c87cb6f&scoped=true&"
import script from "./info-table.vue?vue&type=script&lang=js&"
export * from "./info-table.vue?vue&type=script&lang=js&"
import style0 from "./info-table.vue?vue&type=style&index=0&id=4c87cb6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87cb6f",
  null
  
)

export default component.exports